// extracted by mini-css-extract-plugin
module.exports = {"container":"container--YaPbk","card":"card--5Grkp","card-img":"card-img--1a0wX","card-title":"card-title--8futm"};